import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { UploadFilesField } from './UploadFilesField';
import { UploadFilesSchema } from './UploadFilesFieldSchema';

export const UploadFilesExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UploadFiles',
    component: UploadFilesField,
    schema: UploadFilesSchema,
  }),
);
